import AuthenticatedPage from 'containers/AuthenticatedPage'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import './style.css'
import API from 'lib/api'
import moment from 'moment'
import { CAMPAIGN_LABELS_API } from 'config/app'

const SWADetails = (props) => {
  const id = props.router?.match?.params?.id
  const [bannersConfig, setBannerConfig] = useState([])

  useEffect(() => {
    const api = new API({
      url: `${CAMPAIGN_LABELS_API}/v1/swa-banners/schedules/${id}`,
    })

    api.get().then((resp) => {
      setBannerConfig(resp.data)
    })
  }, [id])

  const goBack = () => {
    window.history.back()
  }

  return (
    <AuthenticatedPage
      menu={props.menu}
      from={props.location && props.location.pathname}
    >
      <div className="swa-header-section">
        <h1>SWA Banner Details - {id}</h1>

        <button className="swa-goback" onClick={goBack}>
          Go Back
        </button>
      </div>

      <div className="swa-details-container">
        <div className="swa-dates">
          <div className="swa-startdate">
            {bannersConfig?.startDate ? (
              <>
                <label className="swa-start-date-label">Start Date</label>
                <span>
                  {bannersConfig?.startDate &&
                    moment(bannersConfig.startDate).format('YYYY-MM-DD HH:mm')}
                </span>
              </>
            ) : (
              ''
            )}
          </div>
          <div className="swa-enddate">
            {bannersConfig?.endDate ? (
              <>
                <label className="swa-end-date-label">End Date</label>
                <span>
                  {bannersConfig?.endDate &&
                    moment(bannersConfig.endDate).format('YYYY-MM-DD HH:mm')}
                </span>
              </>
            ) : (
              ''
            )}
          </div>
        </div>
        <div className="swa-banners">
          {bannersConfig?.data?.length > 0 ? (
            bannersConfig.data.map((item, index) => {
              return (
                <div key={index} className="swa-details-content">
                  <div className="swa-image">
                    <img src={item.imageUrl} alt="image" />
                  </div>
                  <h6 className="swa-links">{item.link}</h6>
                </div>
              )
            })
          ) : (
            <h3>Loading please wait...</h3>
          )}
        </div>
      </div>
    </AuthenticatedPage>
  )
}

export default withRouter(({ match, ...props }) => (
  <SWADetails router={{ match }} {...props} />
))
